var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useContext, useEffect, useRef, useState, } from "react";
import styles from "./marketDepth.module.scss";
import { getCompanyDetailNew, getFutOptStockDetails } from "src/apis/dashboard";
import { COMPANY_DETAILS, EQUITY_SEGMENT, } from "src/utils/constant";
import { DepthSnapToggleContext, PricePickerContext, } from "src/contexts/custom-context";
import { convertNumberIntoLakhsAndCroreWithSign, getSegmentAndProductType, intComma, } from "src/utils/methods";
import moment from "moment";
import { captureApxorEvent } from "src/utils/apxor";
import FinalGuestLogin from "../final-guest-login/final-guest-login";
const { REACT_APP_ENV } = process.env;
const MarketDepthCompName = "MarketDepth";
const MarketDepth = (props) => {
    const { scripData, toggleHideAndShow, pinnedStatus } = props;
    // const [showQuote, setShowQuote] = useState(false);
    const [pinnStatus, setpinStatus] = useState(pinnedStatus);
    const [scriptsQuotesData, setScriptsQuotesData] = useState(COMPANY_DETAILS);
    const { picker, setPicker } = useContext(PricePickerContext);
    const { depthToggle, setDepthSnapToggleContext } = useContext(DepthSnapToggleContext);
    const [segmentType, setSegmentType] = useState("Equity");
    const [weekHighLow, setweekHighLow] = useState({
        high: 0,
        low: 0,
        percentage: 0,
        spotPrice: 0,
    });
    const interval = useRef();
    const lastOrderUpdateTime = useRef(moment().format("YYYY-MM-DD HH:mm:ss"));
    const refreshTime = 15000;
    const [productType, setProductType] = useState();
    useEffect(() => {
        //if (showQuote) {
        if (interval.current) {
            clearTimeout(interval.current);
            interval.current = undefined;
        }
        getAllScriptQuote();
        if (getSegmentAndProductType(scripData.name, scripData.exchange, scripData.exchangeType).segmentType != EQUITY_SEGMENT ||
            scripData.exchange == "B") {
            const getDepthToggle = Object.assign({}, depthToggle);
            setDepthSnapToggleContext({
                show20: false,
                toggleShowQuotes: true,
                fullHeighModal: getDepthToggle.fullHeighModal,
            });
        }
        else {
            const getDepthToggle = Object.assign({}, depthToggle);
            setDepthSnapToggleContext({
                show20: depthToggle.show20,
                toggleShowQuotes: true,
                fullHeighModal: getDepthToggle.fullHeighModal,
            });
        }
        //}
    }, [scripData]);
    useEffect(() => {
        return () => {
            const getDepthToggle = Object.assign({}, depthToggle);
            setDepthSnapToggleContext({
                show20: false,
                toggleShowQuotes: getDepthToggle.toggleShowQuotes,
                fullHeighModal: getDepthToggle.fullHeighModal,
            });
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = undefined;
            }
        };
    }, []);
    useEffect(() => {
        const getDepthToggle = Object.assign({}, depthToggle);
        setDepthSnapToggleContext({
            show20: getDepthToggle.show20,
            toggleShowQuotes: true,
            fullHeighModal: getDepthToggle.fullHeighModal,
        });
    }, []);
    useEffect(() => {
        captureApxorEvent("DepthView_PinClicked", "");
    }, []);
    const futOptStockDetails = (producttype) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        try {
            const futOptionDetails = yield getFutOptStockDetails(scripData.scripCode + "");
            const futData = (_b = (_a = futOptionDetails.data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data;
            // console.log(futData, "futOptionDetails",futData.FutOptIndvidualStockList?.FutOptIndvidualStock);
            if (((_d = (_c = futData.FutOptIndvidualStockList) === null || _c === void 0 ? void 0 : _c.FutOptIndvidualStock) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                const detailData = (_e = futData.FutOptIndvidualStockList) === null || _e === void 0 ? void 0 : _e.FutOptIndvidualStock[0];
                const scriptsQuotesDataClone = Object.assign({}, scriptsQuotesData);
                scriptsQuotesDataClone.Rollover.value = detailData.RollOver;
                scriptsQuotesDataClone.RollCost.value = detailData.RollCost;
                scriptsQuotesDataClone.OIPercChange.value = detailData.OIPercChange;
                //scriptsQuotesDataClone.Spot.value = detailData.Spot;
                setScriptsQuotesData(scriptsQuotesDataClone);
            }
        }
        catch (error) {
            console.error(`something went wrong ${error}`);
        }
        finally {
        }
    });
    const checkSegment = (producttype) => {
        //const producttype = productType;
        let segment = "";
        switch (producttype === null || producttype === void 0 ? void 0 : producttype.segmentType) {
            case "Equity":
                if ((producttype === null || producttype === void 0 ? void 0 : producttype.productType) === "OPTIONS") {
                    segment = "StockOptions";
                }
                else if ((producttype === null || producttype === void 0 ? void 0 : producttype.productType) === "FUTURES") {
                    segment = "StockFuture";
                }
                else {
                    segment = "Equity";
                }
                break;
            case "Currency":
                segment = "CurrencyFuture";
                break;
            case "Commodity":
                segment = "CommodityFuture";
                break;
            default:
                segment = "Equity";
                break;
        }
        // console.log(segment);
        setSegmentType(segment);
        fetchDataforScriptQuote(producttype);
        // if (
        //   (segment === "Equity" && producttype?.productType === "FUTURES") ||
        //   segment === "StockOptions"
        // ) {
        futOptStockDetails(producttype);
        // }
    };
    const fetchDataforScriptQuote = (producttype) => {
        fetchCompanyDetailsData(producttype);
    };
    const setHighLowPercent = (high, low, lastRate) => {
        const calcPerc = ((lastRate - low) / (high - low)) * 100;
        setweekHighLow({
            high: high,
            low: low,
            percentage: calcPerc,
            spotPrice: lastRate,
        });
    };
    const getAllScriptQuote = () => {
        const producttype = getSegmentAndProductType(`${scripData.name}`, scripData.exchange, scripData.exchangeType);
        setProductType(producttype);
        checkSegment(producttype);
    };
    const fetchCompanyDetailsData = (updateData) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h, _j, _k, _l, _m;
        try {
            const companyDetails = yield getCompanyDetailNew(scripData.exchange, scripData.exchangeType, scripData.scripCode);
            if (((_h = (_g = (_f = companyDetails.data) === null || _f === void 0 ? void 0 : _f.body) === null || _g === void 0 ? void 0 : _g.Data) === null || _h === void 0 ? void 0 : _h.length) > 0) {
                const detailData = (_k = (_j = companyDetails.data) === null || _j === void 0 ? void 0 : _j.body) === null || _k === void 0 ? void 0 : _k.Data[0];
                // console.log(detailData, "detailData");
                const scriptsQuotesDataClone = Object.assign({}, scriptsQuotesData);
                scriptsQuotesDataClone.Open.value = intComma(detailData.OpenRate, 2);
                scriptsQuotesDataClone.High.value = intComma(detailData.High, 2);
                scriptsQuotesDataClone.Low.value = intComma(detailData.Low, 2);
                scriptsQuotesDataClone.PClose.value = intComma(detailData.PClose, 2);
                scriptsQuotesDataClone.Volume.value =
                    convertNumberIntoLakhsAndCroreWithSign(Number(detailData.TotalQty));
                scriptsQuotesDataClone.marketCap.value =
                    Number(detailData.MarketCapital) > 99999
                        ? detailData.MarketCapital
                        : convertNumberIntoLakhsAndCroreWithSign(Number(detailData.MarketCapital));
                scriptsQuotesDataClone.upperCircuit.value = intComma((_l = detailData.DPR) === null || _l === void 0 ? void 0 : _l.split("-")[1], 2);
                scriptsQuotesDataClone.lowerCircuit.value = intComma((_m = detailData.DPR) === null || _m === void 0 ? void 0 : _m.split("-")[0], 2);
                scriptsQuotesDataClone.ATP.value =
                    (productType === null || productType === void 0 ? void 0 : productType.segmentType) != "Currency"
                        ? intComma(detailData.AvgRate, 2, 2)
                        : intComma(detailData.AvgRate, 4, 4);
                scriptsQuotesDataClone.INTExposure.value = detailData.BuyMgnIntra;
                scriptsQuotesDataClone.DELExposure.value = detailData.BuyMgnDel;
                scriptsQuotesDataClone.Category.value = detailData.ExposureCategory;
                scriptsQuotesDataClone.OpenInterest.value =
                    convertNumberIntoLakhsAndCroreWithSign(Number(detailData.OpenInterest));
                setScriptsQuotesData(scriptsQuotesDataClone);
                // console.log(detailData.High52Week, detailData.Low52Week, "High Low");
                setHighLowPercent(detailData.High52Week, detailData.Low52Week, detailData.LastRate);
            }
            else {
            }
            // if (updateData){
            // interval.current = setTimeout(
            //   () => fetchCompanyDetailsData(true),
            //   refreshTime
            // );
            // }
            if (interval.current) {
                clearInterval(interval.current);
            }
            interval.current = setTimeout(() => {
                fetchCompanyDetailsData(true);
            }, refreshTime);
        }
        catch (err) {
            // interval.current = setTimeout(
            //   () => fetchCompanyDetailsData(true),
            //   refreshTime
            // );
            console.error(err);
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `${styles.marketDepthSection} d-flex flex-column` }, { children: [_jsxs("div", Object.assign({ className: `${styles.marketDepthHead} d-flex justify-content-between align-items-center` }, { children: [_jsxs("h6", Object.assign({ className: "large regularWeight" }, { children: ["Market Depth ", depthToggle.show20] })), _jsxs("div", Object.assign({ className: "d-flex align-items-center " }, { children: [_jsx("span", Object.assign({ onClick: () => {
                                        var _a;
                                        setpinStatus(!pinnStatus);
                                        (_a = props.pinnedCallBack) === null || _a === void 0 ? void 0 : _a.call(props);
                                    } }, { children: _jsxs("svg", Object.assign({ className: `${styles.pinItIcon} ${pinnStatus ? styles.active : ""} me-2 pointer`, width: "18", height: "18", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M9.98764 2.7616L7.09734 5.6519L4.20703 6.73577L3.12317 7.81963L8.1812 12.8777L9.26507 11.7938L10.3489 8.90349L13.2392 6.01319", stroke: "#060B14", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M5.65198 10.3483L2.40039 13.5999", stroke: "#060B14", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M9.6261 2.3999L13.6003 6.37407", stroke: "#060B14", strokeLinecap: "round", strokeLinejoin: "round" })] })) })), _jsx("span", { onClick: () => {
                                        var _a;
                                        if (toggleHideAndShow) {
                                            (_a = props.closeModalCallBack) === null || _a === void 0 ? void 0 : _a.call(props);
                                        }
                                    }, className: "closeIcon1", title: "Close" })] }))] })), _jsx(FinalGuestLogin, {})] })) }));
};
export default MarketDepth;
